export const state = {
  truckdocuments: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckdocuments/state.js